module.exports = __webpack_public_path__ + "static/img/appeal-page-top-icon.e43f1bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/person/appeal-page-top-icon.png
// module id = gcuM
// module chunks = 1